module.exports = __webpack_public_path__ + "static/media/direction-up.cab2792c.svg";